<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">app升级</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addUpgrade">新增版本</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="mainVersion" label="app版本号" >
        </el-table-column>
        <el-table-column  prop="mainAppName" label="安装包">
        </el-table-column>
        <el-table-column  prop="mainAppSize" label="安装包大小/mb">
        </el-table-column>
        <el-table-column  prop="title" label="消息标题">
        </el-table-column>
        <el-table-column  prop="content" label="消息内容">
        </el-table-column>
        <el-table-column  prop="createdAt" label="发布时间">
            <template slot-scope="scope">
                <div>{{scope.row.createdAt|timestampToTime}}</div>
            </template>
        </el-table-column>
        <el-table-column  prop="adminUser" label="发布人">
        </el-table-column>
        <el-table-column align="center" label="操作" >
            <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="上传安装包" v-if="editFlag == false">
                    <el-upload
                        :http-request="handleChange"
                        :file-list="fileList"
                        accept=""
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="安装包" v-if="editFlag == true">
                    {{ editForm.mainAppName }}
                </el-form-item>
                <el-form-item label="安装包大小" v-if="editFlag == true">
                    {{ editForm.mainAppSize }}mb
                </el-form-item>
                <el-form-item label="版本号" prop="mainVersion">
                    <el-input   el-input size="small" :disabled="editFlag" v-model="editForm.mainVersion" auto-complete="off" placeholder="请输入版本号"></el-input>
                </el-form-item>
                <el-form-item label="是否系统通知" >
                    <el-radio-group :disabled="editFlag" v-model="editForm.pushType">
                        <el-radio :label="1">进行系统通知</el-radio>
                        <el-radio :label="0">不进行系统通知</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="消息标题" v-if="editForm.pushType == 1" prop="title">
                    <el-input size="small" :disabled="editFlag" v-model="editForm.title" auto-complete="off" placeholder="请输入消息标题"></el-input>
                </el-form-item>
                <el-form-item label="消息内容" v-if="editForm.pushType == 1" prop="content">
                    <el-input size="small" :disabled="editFlag" v-model="editForm.content" auto-complete="off" placeholder="请输入消息内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { loadAppVersionList , createAppVersion } from '../../api/userMG'
export default {
    data(){
        return{
            fileList:'',
            editFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            loading:false,
            editForm:{
                pushType:1,
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                title : [
                    { required: true, message: '请输入消息标题', trigger: 'blur' }
                ],
                content : [
                    { required: true, message: '请输入消息内容', trigger: 'blur' }
                ],
                mainVersion : [
                    { required: true, message: '请输入版本号', trigger: 'blur' }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        addUpgrade(){
            this.editFormVisible = true
            this.fileList = []
            this.$refs.editForm.resetFields()
            this.editFlag = false
            this.editForm = {
                pushType:1
            }
        },
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.fileList[0] == undefined){
                        this.$message.error('请上传安装包')
                        return
                    }
                    this.loading = true
                    let formData = new FormData()
                    formData.append('mainVersion' , this.editForm.mainVersion)
                    formData.append('uplaodFile' , this.fileList[0])
                    formData.append('pushType ' , this.editForm.pushType)
                    if(this.editForm.pushType == 1){
                        formData.append('title ' , this.editForm.title)
                        formData.append('content ' , this.editForm.content)
                    }
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/admin/createAppVersion",
                        headers: {
                        "Content-Type": "multipart/form-data",
                        token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res => {
                        if (res.data.success) {
                            this.fileList = []
                            this.editForm = {
                                pushType:1 
                            }
                            this.editFormVisible = false
                            this.loading = false
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.data.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                } else {
                    return false
                }
            })
        },  
        handleChange(file, fileList) {
            this.fileList = [file.file] 
        },
        handleEdit(index , row){
            this.editFormVisible = true
            this.editForm.mainVersion = row.mainVersion
            this.editForm.title = row.title
            this.editForm.content = row.content
            this.editForm.pushType = row.pushType
            this.editForm.mainAppName = row.mainAppName
            this.editForm.mainAppSize = row.mainAppSize
            this.editFlag = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            loadAppVersionList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/Mahjong/appUpgrade.vue